import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { ButtonModule } from 'src/app/libs/ui/components/button/button.module';
import { FlightSliceSummaryModule } from '../flight-slice-summary/flight-slice-summary.module';
import { FlightOptionModule } from '../flight-option/flight-option.module';
import { FlightResultComponent } from './flight-result.component';
import { CurrencyExchangeConverterModule } from 'src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule';
import { AbsModule } from 'src/app/libs/common/pipes/abs/abs.module';

@NgModule({
  declarations: [
    FlightResultComponent,
  ],
  imports: [
    CommonModule,
    I18nModule.forRoot(AppSupportedLanguages),
    FlightOptionModule,
    ButtonModule,
    MatExpansionModule,
    FlightSliceSummaryModule,
    FlightOptionModule,
    CurrencyExchangeConverterModule,
    AbsModule
  ],
  exports: [
    FlightResultComponent,
  ]
})
export class FlightResultModule { }
